// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;There is a river whose streams make glad the city of God,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the holy place of the dwelling of the Most High.<br> </p> </div></div>";
// Exports
module.exports = code;